<div class="table-container">
  <table mat-table [dataSource]="summaries" aria-label="Product Summary">
    <ng-container matColumnDef="item">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.ITEM' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="icon-and-name">
          <div class="icon-container">
            <va-icon [diameter]="32" [iconUrl]="row.icon" [iconName]="row.name"></va-icon>
          </div>
          <div>
            <div class="title">
              {{ row.name }}
              <span *ngIf="row.editionName">&nbsp;| {{ row.editionName }}</span>
            </div>
            <div class="subtitle">
              {{ row.addonId || row.appId }}
              <span *ngIf="row.editionId">&nbsp;| {{ row.editionId }}</span>
            </div>
          </div>
          <mat-icon
            *ngIf="isNonInstant(row)"
            class="message-icon"
            [matTooltip]="
              'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.PRICES_ESTIMATED_AND_CALCULATED_END_OF_MONTH'
                | translate
            "
          >
            help_outline
          </mat-icon>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="wholesale">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.WHOLESALE' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <a (click)="openChangePriceDialog(row)" *ngIf="row.effectiveAppPrice?.billingConfiguration.usesVariablePricing">
          {{ 'COMMON.ACTION_LABELS.EDIT' | translate }}
        </a>
        <div class="price-display">
          <billing-ui-simple-price-display
            [price]="row.generalPriceInfo.price"
            [frequency]="row.generalPriceInfo.frequency"
            [currencyCode]="row.partnerCurrency"
            [setupFee]="row.generalPriceInfo.setupFee"
            [commitment]="row.generalPriceInfo.commitment"
            [stairSteps]="row.generalPriceInfo.stairSteps"
            [discounts]="row.generalPriceInfo.discounts"
            [fees]="row.generalPriceInfo.fees"
            [contactSales]="row.generalPriceInfo.contactSales"
          ></billing-ui-simple-price-display>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="qty">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.QUANTITY_SHORT' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="purchase-name-row">
          {{ row.quantity }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="retail price">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.RETAIL_PRICE' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <billing-ui-price-display
          class="purchase-name-row"
          [appPrice]="row.appPrices.pricesForContexts['retail']"
          [editionId]="row.editionId || ''"
          [align]="'start'"
          [currencyCode]="row.marketCurrency"
        ></billing-ui-price-display>
      </td>
    </ng-container>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.AMOUNT' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="price-display">
          <billing-ui-simple-price-display
            [price]="row.generalPriceInfoRetail.price"
            [frequency]="row.generalPriceInfoRetail.frequency"
            [currencyCode]="row.marketCurrency"
            [setupFee]="row.generalPriceInfoRetail.setupFee"
            [commitment]="row.generalPriceInfoRetail.commitment"
            [stairSteps]="row.generalPriceInfoRetail.stairSteps"
            [discounts]="row.generalPriceInfoRetail.discounts"
            [fees]="row.generalPriceInfoRetail.fees"
            [contactSales]="row.generalPriceInfoRetail.contactSales"
          ></billing-ui-simple-price-display>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="invoice-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<!--Totals Section-->
<div *ngIf="!hidePricing">
  <div class="totals-card-layout" *ngIf="summaries; else displayStencil">
    <div class="total-header">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.TOTALS' | translate }}
    </div>
    <div class="total">
      <div class="col total-col">
        <strong>
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.WHOLESALE' | translate }}
        </strong>
      </div>
      <div class="col total-col-price">
        <div class="row">
          <div class="col col-xs-12 total--charge">
            <strong *ngIf="!contactSalesForOrder">
              <billing-ui-simple-price-display
                [price]="total"
                [currencyCode]="currency"
              ></billing-ui-simple-price-display>
            </strong>
            <strong *ngIf="contactSalesForOrder">
              <billing-ui-simple-price-display [contactSales]="true"></billing-ui-simple-price-display>
            </strong>
          </div>
        </div>
        <div class="row" *ngFor="let charge of recurringTotals | keyvalue; let first = first">
          <div class="col col-xs-4 total--recurring-description">
            <span *ngIf="first">
              {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.RECURRING' | translate }}
            </span>
          </div>
          <div class="col col-xs-8 total--recurring-charge">
            <div class="price-box">
              <billing-ui-simple-price-display
                [price]="charge.value.total"
                [frequency]="charge.value.frequency"
                [currencyCode]="currency"
                [componentTextLength]="'verbose'"
              ></billing-ui-simple-price-display>
            </div>
          </div>
        </div>
      </div>
      <div class="col total-col">
        <strong>
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.RETAIL' | translate }}
        </strong>
      </div>
      <div class="col total-col-price" *ngIf="retailCurrency">
        <div class="row">
          <div class="col col-xs-12 total--charge">
            <strong *ngIf="!contactSalesForOrder">
              <billing-ui-simple-price-display
                [price]="retailTotal"
                [currencyCode]="currency"
              ></billing-ui-simple-price-display>
            </strong>
            <strong *ngIf="contactSalesForOrder">
              <billing-ui-simple-price-display [contactSales]="true"></billing-ui-simple-price-display>
            </strong>
          </div>
        </div>
        <div
          class="row retail-row"
          *ngFor="let charge of recurringRetailTotals | keyvalue; let first = first; let second = second"
        >
          <div class="col col-xs-4 total--recurring-description">
            <span *ngIf="first">
              {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE_SUMMARY.RECURRING' | translate }}
            </span>
          </div>
          <div class="col col-xs-8 total--recurring-charge">
            <div class="price-box">
              <billing-ui-simple-price-display
                [price]="charge.value.total"
                [frequency]="charge.value.frequency"
                [currencyCode]="retailCurrency"
                [componentTextLength]="'verbose'"
              ></billing-ui-simple-price-display>
            </div>
          </div>
          <div class="col col-xs-4 total--recurring-description"></div>
          <div *ngIf="second" class="col col-xs-8 total--recurring-charge">
            <div class="price-box">
              <billing-ui-simple-price-display
                [price]="charge.value.total"
                [frequency]="charge.value.frequency"
                [currencyCode]="retailCurrency"
                [componentTextLength]="'verbose'"
              ></billing-ui-simple-price-display>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #displayStencil>
  <div class="stencil-shimmer"></div>
</ng-template>
